import { SpeakerListResponseType } from '../api';
import { DateFnsFormats, dateToFormattedString, getFullDateInUsEuFormat, getIsEnUsRegion } from "./dateHelper";

export const getGroupedMeetingsList = <T extends { startDateTime: string }>
  (meetings: T[], isCarouselViewByDay: boolean, timeZone: string): { [date: string]: T[] } => {
  
  const groupedMeetingsList: { [date: string]: T[] } = {};
  meetings.forEach((meeting: T) => {
    const startDate = isCarouselViewByDay
      ? getFullDateInUsEuFormat(meeting.startDateTime, timeZone)
      : dateToFormattedString(meeting.startDateTime, 
        getIsEnUsRegion() ? DateFnsFormats.StringifiedUSShortDay : DateFnsFormats.StringifiedEUShortDay,
        timeZone);
    if (groupedMeetingsList[startDate]) {
      groupedMeetingsList[startDate].push(meeting);
    } else {
      groupedMeetingsList[startDate] = [meeting];
    }
  });
  return groupedMeetingsList;
};

export const sortOrganizationsByPriorityInEvent = (
  organizations: SpeakerListResponseType = []
): SpeakerListResponseType => {
  return [...organizations].sort((a, b) => {
    const aPriority = a.priorityInEvent ?? null;
    const bPriority = b.priorityInEvent ?? null;

    if (aPriority !== null && bPriority !== null) {
      if (aPriority !== bPriority) {
        return aPriority - bPriority;
      }
    }

    else if (aPriority === null && bPriority !== null) {
      return 1;
    } else if (aPriority !== null && bPriority === null) {
      return -1;
    }

    return a.name.localeCompare(b.name);
  });
};
